import { render, staticRenderFns } from "./WeChatActionButton.vue?vue&type=template&id=422689e0&scoped=true&"
import script from "./WeChatActionButton.vue?vue&type=script&lang=js&"
export * from "./WeChatActionButton.vue?vue&type=script&lang=js&"
import style0 from "./WeChatActionButton.vue?vue&type=style&index=0&id=422689e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422689e0",
  null
  
)

export default component.exports